/* eslint-disable react/jsx-handler-names */
import { useToaster } from '../hooks/useToaster.js';
import { Toast } from './Toast/Toast.js';
import { useCallback } from 'react';
import { css, styled } from 'styled-components';

const StyledToaster = styled.div`
  ${({ theme }) => css`
    position: fixed;
    z-index: ${theme.zIndices.toaster};
    top: 0;
    right: 0;
  `}
`;

export const Toaster = () => {
  const { handlers, toasts } = useToaster();

  const handleHeight = useCallback(
    (toastId: string, height: number) => {
      handlers.updateHeight(toastId, height);
    },
    [handlers],
  );

  return (
    <StyledToaster
      onMouseEnter={handlers.startPause}
      onMouseLeave={handlers.endPause}
      // here to allow events
      // while modal has locked pointer events
      style={{
        pointerEvents: toasts.length > 0 ? 'auto' : 'none',
      }}
    >
      {toasts.map((toast) => (
        <Toast
          key={toast.id}
          offset={handlers.calculateOffset(toast.id)}
          onHeight={handleHeight}
          toast={toast}
        />
      ))}
    </StyledToaster>
  );
};
